// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TQy-","type":"styles_type__1SujH","choices":"styles_choices__2yg4S"};